/**
 * Converts an array of IDs into a format suitable for table row selection.
 *
 * @param array - An array of strings or numbers representing IDs.
 * @returns A record where each ID is a key with a value of `true`.
 */
export function idsToTableSelectedRowFormat(array: string[] | number[]): Record<string, boolean> {
  return array.reduce(
    (acc, item) => {
      acc[item] = true
      return acc
    },
    {} as Record<string, boolean>
  )
}
